import http from 'hub-http/clients/apiClient';
const BASE_URL = 'users/v2';
export default {
  fetchUsersByScope: scope => http.get(`${BASE_URL}/app/scopes/${scope}/hub-users`)
};